// this breakpoint setting is based Material-UI breakpoint(md,sm);
export const firstBreakpointWidth: number = 960;

export const secondBreakpointWidth: number = 600;
